import type { KioskStore } from './kiosk-store';
import type { ModuleConfig } from '@museum-kiosk/shared-types';

export type Screen = 'provisioning' | 'attract' | 'selector';

/**
 * Returns enabled modules sorted by display_order ascending.
 */
export function selectEnabledModules(state: KioskStore): ModuleConfig[] {
  if (!state.config) return [];
  return state.config.enabled_modules
    .filter((m) => m.enabled)
    .sort((a, b) => a.display_order - b.display_order);
}

/**
 * Returns true when the stored JWT has expired (or was never set).
 */
export function selectIsJwtExpired(state: KioskStore): boolean {
  if (!state.jwtExpiresAt) return true;
  return Date.now() >= state.jwtExpiresAt;
}

/**
 * Derives the screen to display based on store state.
 *
 * - Not provisioned → provisioning
 * - Provisioned, no active session → attract
 * - Provisioned, active session → selector
 */
export function selectCurrentScreen(state: KioskStore): Screen {
  if (!state.isProvisioned) return 'provisioning';
  if (!state.sessionId) return 'attract';
  return 'selector';
}
